/**
 * Image Provider Interface — future stock-image integration point.
 *
 * The Template Factory already produces semantic image queries ("burger
 * studio shot"); an image provider turns queries into image descriptors.
 * No provider is implemented today (no Pixabay, no network) — the mock
 * returns labeled placeholders so the pipeline shape is testable offline.
 */

import { NotImplementedError } from './providerInterface';

/**
 * Abstract base.
 * search(query, { count, orientation }) → Promise<[{
 *   id, url, thumbUrl, width, height, credit, provider
 * }]>
 */
export class ImageProvider {
  constructor({ id, name } = {}) {
    if (new.target === ImageProvider) {
      throw new NotImplementedError('ImageProvider is abstract — extend it');
    }
    this.id = id;
    this.name = name;
  }

  isReady() {
    return false;
  }

  // eslint-disable-next-line no-unused-vars
  async search(query, options = {}) {
    throw new NotImplementedError(`${this.name}.search() is not implemented`);
  }
}

/** Offline placeholder provider — descriptors only, no URLs fetched. */
export class MockImageProvider extends ImageProvider {
  constructor() {
    super({ id: 'mock-images', name: 'Mock Images (offline)' });
  }

  isReady() {
    return true;
  }

  async search(query, { count = 3 } = {}) {
    return Array.from({ length: count }, (_, i) => ({
      id: `mock_${query.replace(/\s+/g, '_')}_${i + 1}`,
      url: null, // future providers return real URLs
      thumbUrl: null,
      width: 1920,
      height: 1280,
      credit: 'placeholder',
      provider: this.id,
      query,
    }));
  }
}

export const mockImageProvider = new MockImageProvider();
